import { MessagingClient } from "@whatslly/commons/messagingClient";
import { ContentCommands, ContentCommandsTypes } from "@whatslly/commons/contentCommands";

export const contentMessagingClient = new MessagingClient<ContentCommandsTypes>(ContentCommands);
